// Region badge: maps backend region to flag emoji + tone
const REGIONS = {
    EU: { flag: "🇪🇺", label: "EU" },
    US: { flag: "🇺🇸", label: "US" },
    Asia: { flag: "🌏", label: "Asia" },
    LATAM: { flag: "🌎", label: "LATAM" },
    MEA: { flag: "🌍", label: "MEA" },
    Global: { flag: "🌐", label: "Global" },
    Other: { flag: "·", label: "Other" },
};

export const REGION_KEYS = Object.keys(REGIONS);

export function RegionBadge({ region, className = "" }) {
    const r = REGIONS[region] || REGIONS.Other;
    return (
        <span
            data-testid={`region-badge-${region || "Other"}`}
            className={`inline-flex items-center gap-1 border border-zinc-700 bg-zinc-900/60 text-zinc-300 text-[10px] font-mono uppercase tracking-wider px-1.5 py-0.5 ${className}`}
        >
            <span className="text-xs leading-none">{r.flag}</span> {r.label}
        </span>
    );
}
